import React, {useEffect, useRef, useState} from "react";
// reactstrap components
import {Card, CardBody, CardHeader} from "reactstrap";
// core components
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import ReportsHeader from "../../components/Headers/ReportsHeader";
import {Redirect} from "react-router-dom";
import reportApiService from "../../api/report-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const About = (callback, deps) => {

    useEffect(() => {
        reportApiService.ahoy("about_view")
    }, []);

    const [goToBusiness, setGoToBusiness] = useState(false);

    const rulesRef = useRef(null);
    const regClientsRef = useRef(null);
    const ttRef = useRef(null);
    const ctRef = useRef(null);
    const teachersRef = useRef(null);
    const clientAppRef = useRef(null);

    localize();

    function goToProfile(e) {
        e.preventDefault();
        setGoToBusiness(true);
    }

    function goToClassTypes(e) {
        e.preventDefault();
        window.scrollTo(0, ctRef.current.offsetTop)
    }

    function goToTicketTypes(e) {
        e.preventDefault();
        window.scrollTo(0, ttRef.current.offsetTop)
    }

    function goToTeachers(e) {
        e.preventDefault();
        window.scrollTo(0, teachersRef.current.offsetTop)
    }

    function introBody() {
        return <p>
            {commonStrings.tutorial.how_to_start.body_1} <b><a href="#_"
                                                               onClick={e => goToProfile(e)}>{commonStrings.navigation.profile}</a></b>
            {" " + commonStrings.tutorial.how_to_start.body_2} <b><a href="#_"
                                                                     onClick={e => goToClassTypes(e)}>{resourceStrings.class_types}</a></b>
            {", "}<b> <a href="#_" onClick={e => goToTicketTypes(e)}>{resourceStrings.ticket_types}</a></b>
            {", "}<b> <a href="#_" onClick={e => goToTeachers(e)}>{resourceStrings.teachers}</a></b>
            {" " + commonStrings.tutorial.how_to_start.body_3}
        </p>
    }

    if (goToBusiness === true) {
        return <Redirect from="*" to="/admin/user-profile"/>
    }

    function goToRules(e) {
        e.preventDefault();
        window.scrollTo(0, rulesRef.current.offsetTop)
    }

    function goToRegularClients(e) {
        e.preventDefault();
        window.scrollTo(0, regClientsRef.current.offsetTop)
    }

    function classTypeBody() {
        return <p>
            {commonStrings.tutorial.class_types.body_1} <b><a href="#_"
                                                              onClick={e => goToRules(e)}>{commonStrings.tutorial.class_types.body_1_1}</a></b>
            {commonStrings.tutorial.class_types.body_2} <b><a href="#_"
                                                              onClick={e => goToRegularClients(e)}>{commonStrings.tutorial.class_types.body_3}</a></b>
            {commonStrings.tutorial.class_types.body_4}
        </p>
    }

    function roomsBody() {
        return <p>
            {commonStrings.tutorial.rooms.body_1} <b><a href="#_"
                                                              onClick={e => goToRules(e)}>{commonStrings.tutorial.rooms.body_2}</a></b>
            {commonStrings.tutorial.rooms.body_3} <b><a href="#_"
                                                              onClick={e => goToClientApp(e)}>{commonStrings.tutorial.rooms.body_4}</a></b>
            {commonStrings.tutorial.rooms.body_5}
        </p>
    }

    function goToClientApp(e) {
        e.preventDefault();
        window.scrollTo(0, clientAppRef.current.offsetTop)
    }

    function teachersBody() {
        return <p>
            {commonStrings.tutorial.teachers.body_1} <b><a href="#_"
                                                              onClick={e => goToClientApp(e)}>{commonStrings.tutorial.teachers.body_2}</a></b>
            {commonStrings.tutorial.teachers.body_3}
        </p>
    }

    function onlineTicketsBody() {
        return <p>
            {commonStrings.tutorial.online_tickets.body_1} <b><a href="#_"
                                                                 onClick={e => goToClientApp(e)}>{commonStrings.tutorial.online_tickets.body_2}</a></b>
            {commonStrings.tutorial.online_tickets.body_3} <b><a href="https://stripe.com/" target="blank"
                                                        >{commonStrings.tutorial.online_tickets.body_4}</a></b>
            {commonStrings.tutorial.online_tickets.body_5}
        </p>
    }

    function clientAppBody() {
        return <p>
            {commonStrings.tutorial.client_app.body_1}<br/>
            <b><a href="https://apps.apple.com/us/app/open-client/id1478628247" target="blank" >{commonStrings.tutorial.client_app.body_2}</a></b><br/>
            <b><a href="https://play.google.com/store/apps/details?id=com.openclient" target="blank">{commonStrings.tutorial.client_app.body_3}</a></b><br/>
        </p>
    }

    function clientMembershipBody() {
        return <p>
            {commonStrings.tutorial.memberships.body_1}<br/>
        </p>
    }

    return (
        <>
            {/*<LandingComponent/>*/}
            <ReportsHeader/>
            {/* Page content */}
            <Card className="bg-secondary shadow">

                <CardHeader className="bg-white border-0">
                </CardHeader>
                <CardBody>

                    <div
                        style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.how_to_start.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {introBody()}
                            </span>
                            </small>
                        </div>
                    </div>
                    {/*CLASS TYPES*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.class_types.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span ref={ctRef} style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {classTypeBody()}
                            </span>
                            </small>
                        </div>
                    </div>
                    {/*RULES*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.rules.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                <p ref={rulesRef}>{commonStrings.tutorial.rules.body_1}</p>
                            </span>
                            </small>
                        </div>
                    </div>
                    {/*REG CLIENTS*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.regular_clients.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                <p ref={regClientsRef}>{commonStrings.tutorial.regular_clients.body_1}</p>
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*TICKET TYPES*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{resourceStrings.ticket_types}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                <p ref={ttRef}>{commonStrings.tutorial.ticket_types.body_1}</p>
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*TEACHERS*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{resourceStrings.teachers}</h3>

                        <div className="align-items-start">
                            <small>
                            <span ref={teachersRef} style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {teachersBody()}
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*ROOMS*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{resourceStrings.rooms}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {roomsBody()}
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*PP*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{resourceStrings.public_profile.public_profile}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                <p>{commonStrings.tutorial.pp.body_1}</p>
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*ONLINE TICKETS*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.online_tickets.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {onlineTicketsBody()}
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*CLIENT APP*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.client_app.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span ref={clientAppRef} style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {clientAppBody()}
                            </span>
                            </small>
                        </div>
                    </div>

                    {/*MEMBERSHIPS*/}
                    <div className="mt-5"
                         style={{width: "100%", textAlign: "left"}}>
                        <h3>{commonStrings.tutorial.memberships.title}</h3>

                        <div className="align-items-start">
                            <small>
                            <span ref={clientAppRef} style={{overflowWrap: 'break-word', whiteSpace: "pre-line"}}>
                                {clientMembershipBody()}
                            </span>
                            </small>
                        </div>
                    </div>

                </CardBody>
            </Card>
        </>
    );

    function goToDashboard() {

    }

    function localize() {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

};

export default About;
